export default "__VITE_ASSET__CMXntoHo__"